module.exports = __webpack_public_path__ + "img/钟表-2.4b1d7509.png";